import { InfoIconWithTooltip, SlideToggle } from '@ygtechnologies/bygr-frontend-component-library';
import PrimaryCard from 'components/Statistics/PrimaryCard';
import theme from './Profile.module.scss';
import React from 'react';
import { useAsyncStateWithIsLoading } from 'utils/hooks';
import { createRubenProfileLicense, getRubenProfileLicense, setRubenProfileLicenseItem } from 'services/rubenLicense';
import { BygrProfileDetails, RubenProfileLicenseDto, RubenProfileLicenseItemType } from 'types';

interface ProfileLicensesProps {
    profile: BygrProfileDetails;
    reloadProfile(): void;
}

const ProfileLicenses: React.FC<ProfileLicensesProps> = (props) => {
    const [rubenLicense, , reloadRubenLicense, isLoadingRubenLicense] = useAsyncStateWithIsLoading(
        () => getRubenProfileLicense(props.profile.id),
        [props],
        null
    );

    const handleLicenseToggle = async (checked, type) => {
        let license = rubenLicense; // This is a funcky way to handle the license, but it works.
        if (rubenLicense === null) {
            license = await createLicense();
        }

        if (checked) {
            await setRubenProfileLicenseItem(props.profile.id, {
                profileLicenseId: license!.id,
                type: type,
                isActive: true,
            });
        } else {
            await setRubenProfileLicenseItem(props.profile.id, {
                profileLicenseId: license!.id,
                type: type,
                isActive: false,
            });
        }
        reloadRubenLicense();
    };

    const createLicense = async (): Promise<RubenProfileLicenseDto> => {
        const newLicense = await createRubenProfileLicense(props.profile.id, {
            id: 0,
            profileId: props.profile.id,
            profileName: props.profile.name,
            projectLicenses: [],
            items: [],
        });

        return newLicense;
    };

    return (
        <div className={theme.licenses}>
            <PrimaryCard title={'Ruben'} loading={isLoadingRubenLicense}>
                <div className={theme.licenseRow}>
                    <div>View Ruben analytics</div>
                    <div className={theme.licenseTooltip}>
                        <InfoIconWithTooltip
                            content={
                                'This gives access for all users on this profile to view Ruben case analytics data in any project they are a part of, if the project has a active ruben case analytics license.'
                            }
                        />
                    </div>
                    <SlideToggle
                        className={theme.licenseToggle}
                        checked={
                            rubenLicense?.items.find((x) => x.type === RubenProfileLicenseItemType.CanViewRubenCaseData)
                                ?.isActive ?? false
                        }
                        onChange={(e) =>
                            handleLicenseToggle(e.target.checked, RubenProfileLicenseItemType.CanViewRubenCaseData)
                        }
                    />
                </div>
            </PrimaryCard>

            {/* <PrimaryCard title={'Power BI'}>
                
            </PrimaryCard> */}
        </div>
    );
};

export default ProfileLicenses;
